import { render } from "./duplicate-alert-reason-modal.vue?vue&type=template&id=41681d12&ts=true"
import script from "./duplicate-alert-reason-modal.ts?vue&type=script&lang=ts&external"
export * from "./duplicate-alert-reason-modal.ts?vue&type=script&lang=ts&external"

import "./duplicate-alert-reason-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__